import { Text } from '@weareconceptstudio/core';

//* Styles
import DescriptionStyle from './style';

//* Component
import Editor from '@/components/Editor';

const Description = ({ items }) => {
	return (
		<DescriptionStyle>
			<div className='wrapper-container'>
				{items.map((item, i) => {
					return (
						<div
							key={i}
							className={'wrapper-information'}
						>
							<Text className={'p1 font-larken-regular title-text'}>{item.title}</Text>

							<Editor data={item.description} />

							{i === items.length - 1 ? null : <div className='line' />}
						</div>
					);
				})}
			</div>
		</DescriptionStyle>
	);
};

export default Description;
